import { StatusBadge } from "@/components/ui";

import { canvasLabel, namespaced, publisherOf } from "../lib/canvasKinds";
import { needsMachine, requirementKind } from "../lib/requirements";

export function CanvasKindChip({ kind }: { readonly kind: string }) {
  const prefix = publisherOf(kind);
  return (
    <span className={namespaced(kind) ? "cx-chip cx-chip-ns" : "cx-chip"}>
      {prefix === null ? null : <span className="cx-chip-prefix">{`${prefix}.`}</span>}
      {canvasLabel(kind)}
    </span>
  );
}

export function CanvasChips({ kinds }: { readonly kinds: readonly string[] }) {
  return (
    <div className="cx-chips">
      {kinds.map((kind) => (
        <CanvasKindChip key={kind} kind={kind} />
      ))}
    </div>
  );
}

/** How many instances there are, and who reaches one. */
export function CanvasScopeChip({
  scope,
  attach,
}: {
  readonly scope: string;
  readonly attach: string;
}) {
  return (
    <span className="cx-scope">
      scope <b>{scope}</b> attach <b>{attach}</b>
    </span>
  );
}

export function Chip({
  children,
  tone,
}: {
  readonly children: string;
  readonly tone?: "ns" | undefined;
}) {
  return <span className={tone === "ns" ? "cx-chip cx-chip-ns" : "cx-chip"}>{children}</span>;
}

const AVAILABILITY_TONE: Record<string, "neutral" | "warning" | "danger"> = {
  deprecated: "warning",
  withdrawn: "danger",
  revoked: "danger",
};

/** A withdrawn, deprecated or revoked version, labelled rather than silently missing (CAT-017). */
export function AvailabilityBadge({
  availability,
}: {
  readonly availability?: string | undefined;
}) {
  const value = availability ?? "published";
  if (value === "published") return null;
  return <StatusBadge tone={AVAILABILITY_TONE[value] ?? "neutral"}>{value}</StatusBadge>;
}

/** The kind read off the type name, and whatever the registry says the name means. */
export function ReqKindChip({
  type,
  summary,
}: {
  readonly type: string;
  readonly summary?: string;
}) {
  return (
    <span className="cx-kind" title={summary ?? ""}>
      {requirementKind(type)}
      {needsMachine(type) ? <span className="cx-kind-local">needs a machine</span> : null}
    </span>
  );
}
